import React from 'react';

import { Box } from '../../../Box';
import { Button } from '../../../Button';
import { EntitySymbol } from '../../../EntitySymbol';
import { Icons } from '../../../Icons';
import { DrawerTitle } from '../DrawerTitle';

type DrawerHeaderProps = {
  onDrawerClose: () => void;
  title: string | React.ReactNode;
  titleIconVariant?: React.ComponentProps<typeof EntitySymbol>['variant'];
  maxTitleLines?: number;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
};

const DrawerHeader = ({
  onDrawerClose,
  title,
  titleIconVariant,
  maxTitleLines = 5,
  leftContent,
  rightContent,
}: DrawerHeaderProps) => {
  return (
    <Box pt={6} pr={8} pb={6} pl={8}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={6}
      >
        <Box display="flex" flex="1" justifyContent="space-between" mr={1}>
          <Box>{leftContent}</Box>
          <Box>{rightContent}</Box>
        </Box>
        <Button
          variant="text"
          onClick={onDrawerClose}
          startIcon={Icons.Close}
          aria-label="close drawer"
        />
      </Box>
      <DrawerTitle
        title={title}
        titleIconVariant={titleIconVariant}
        maxTitleLines={maxTitleLines}
      />
    </Box>
  );
};

export { DrawerHeader };
